import { useQuery } from 'react-query';

import { ManagerAccount } from '@/domain/models/AuthEnterprise';
import { errorHandler } from '@/lib//ErrorHandler';
import { getClient } from '@/lib/restClient';
import { AuthEnterpriseService } from '@/services/AuthEnterprise';

interface ManagerAccounts {
  managerAccounts?: ManagerAccount[];
  isLoading: boolean;
  isError: Error | null;
}

export const useManagerAccount = (): ManagerAccounts => {
  const authEnterpriseService = new AuthEnterpriseService(getClient());

  const {
    data: managerAccounts,
    error,
    isLoading,
  } = useQuery<ManagerAccount[], Error>('managerAccounts', () =>
    authEnterpriseService
      .accountList()
      .catch((error: Error) => errorHandler({ error }))
  );

  return {
    managerAccounts,
    isLoading,
    isError: error,
  };
};
